


























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import BasicSelect from '@/components/common/BasicSelect.vue';

@Component({
  components: {
    BasicSelect,
  },
})
export default class SubQuestionSelectModal extends Vue {

  get questionOptions() {
    return this.questions
      .filter((q) => q.id !== this.currentQuestionId)
      .map((q) => ({
        name: q.question || `質問 ${q.id}`,
        value: q.id,
      }));
  }

  get filteredQuestions() {
    let list = this.questions;

    // Exclude the current parent question
    if (this.currentQuestionId !== null) {
      list = list.filter((q) => q.id !== this.currentQuestionId);
    }

    // Filter by search query
    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase().trim();
      list = list.filter((q) => {
        const text = (q.question || '').toLowerCase();
        const id = String(q.id).toLowerCase();
        return text.includes(query) || id.includes(query);
      });
    }

    return list;
  }
  @Prop({ default: () => [] }) questions!: any[];
  @Prop({ default: null }) currentQuestionId!: number | string | null;
  @Prop({ default: () => [] }) initialSelectedIds!: Array<number | string>;
  @Prop({ default: 'sub-question-select' }) modalName!: string;

  selectedIds: Array<number | string> = [];
  searchQuery: string = '';
  private snapshotSelectedIds: Array<number | string> = [];
  private isCommitted: boolean = false;

  isSelected(id: number | string): boolean {
    return this.selectedIds.some((sid) => String(sid) === String(id));
  }

  toggleSelection(id: number | string) {
    const index = this.selectedIds.findIndex((sid) => String(sid) === String(id));
    if (index === -1) {
      this.selectedIds.push(id);
    } else {
      this.selectedIds.splice(index, 1);
    }
  }

  handleBeforeOpen(event?: { params?: { initialIds?: Array<number | string> } }) {
    this.isCommitted = false;
    const source = event?.params?.initialIds ?? this.initialSelectedIds;
    this.snapshotSelectedIds = source ? [...source] : [];
    this.selectedIds = [...this.snapshotSelectedIds];
  }

  handleBeforeClose() {
    if (!this.isCommitted) {
      this.selectedIds = [...this.snapshotSelectedIds];
    }
  }

  handleSave() {
    this.isCommitted = true;
    this.$emit('onSave', [...this.selectedIds]);
    this.$modal.hide(this.modalName);
  }

  handleCancel() {
    this.selectedIds = [...this.snapshotSelectedIds];
    this.$emit('onCancel');
    this.$modal.hide(this.modalName);
  }
}
